import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';

//containers
import AuthUserContainer from '../../../containers/AuthUser';
import PtoRequestContainer from '../../../containers/PtoRequest';
import PtoRequiredRequestContainer from '../../../containers/RequiredPtoRequest';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import FormContainer from '../../../components/FormContainer';
import SectionHeader from '../../../components/SectionHeader';
import FormDatePicker from '../../../components/form/FormDatePicker';
import FormSubmitButton from '../../../components/form/FormSubmitButton';
import FormComponent from '../../../components/FormComponent';
import { getGlobalClasses } from '../../../themes';
import Note from '../../../components/Note';
import FormCheckbox from '../../../components/form/FormCheckbox';
import FormText from '../../../components/form/FormText';
import { Button, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import FormTextArea from '../../../components/form/FormTextArea';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		deleteButton: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		addGroupButton: {
			borderRadius: '100px',
			fontSize: 16,
		},
		groupContainer: {
			borderLeft: '4px solid #ddd',
			marginLeft: 10,
			paddingLeft: 5,
			marginBottom: 20,
		},
		totalSection: {
			fontSize: 26,
			padding: 20,
			border: '1px solid #3faff5',
			margin: 10,
		},
		updateTotalSection: {
			fontSize: 20,
			border: '1px solid #3faff5',
			padding: 20,
			margin: 10,
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			color: 'white',
			marginRight: 10,
			marginTop: 30,
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 60px',
			textTransform: 'uppercase',
		},
	};
};

const idField = 'ptoRequestId';

class SavePtoRequest extends FormComponent {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);
		const isUpdate = action === 'update';
		const isAddRequired = action === 'addRequired';
		this.requiredPathMap = {};

		// noinspection JSUnresolvedFunction
		this.state = {
			isUpdate,
			isAddRequired,
			[idField]: id,
			formFieldError: {},
			signatureDate: moment().format('YYYY-MM-DD'),
			dateAndHours: [
				{
					date: '',
					hours: '',
				},
			],
		};
	}
	componentDidMount() {
		const { ptoRequest, getPtoRequest } = this.props;
		const { ptoRequestId, isUpdate, isAddRequired } = this.state;

		if (isAddRequired) {
			const { myRequiredPtoRequests, searchRequiredPtoRequests } = this.props;
			if (!myRequiredPtoRequests) {
				searchRequiredPtoRequests({
					params: {
						searchFor: 'myRequests',
					},
				});
			} else {
				this.fillForm();
			}
		}

		//- update
		if (!isUpdate) {
			return;
		}
		if (ptoRequest) {
			this.fillForm({ ptoRequest });
		} else {
			getPtoRequest({
				params: { ptoRequestIds: [ptoRequestId] },
			});
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (_.isUndefined(prevProps.ptoRequest) && !_.isUndefined(this.props.ptoRequest)) {
			this.fillForm();
		}

		if (
			_.isUndefined(prevProps.myRequiredPtoRequests) &&
			!_.isUndefined(this.props.myRequiredPtoRequests)
		) {
			this.fillForm();
		}

		const { isUpdate } = this.state;
		if (!isUpdate) {
			if (this.state.ptoPaid !== prevState.ptoPaid) {
				if (this.state.ptoPaid) {
					this.setState({ ptoPaidSickPaid: false, ptoCashOut: false });
				}
			}
			if (this.state.ptoPaidSickPaid !== prevState.ptoPaidSickPaid) {
				if (this.state.ptoPaidSickPaid) {
					this.setState({ ptoPaid: false, ptoCashOut: false });
				}
			}

			if (this.state.ptoCashOut !== prevState.ptoCashOut) {
				if (this.state.ptoCashOut) {
					this.setState({ ptoPaid: false, ptoPaidSickPaid: false });
				}
			}
		}
	}

	fillForm = () => {
		const { ptoRequest, myRequiredPtoRequests } = this.props;

		const newState = {};
		if (myRequiredPtoRequests) {
			newState.ptoPaid = true;
			const allDatesAndHours = [];
			myRequiredPtoRequests.forEach((myRequiredPtoRequest) => {
				console.log('myRequiredPtoRequest', myRequiredPtoRequest);
				allDatesAndHours.push(...myRequiredPtoRequest.dateAndHours);
			});
			console.log(allDatesAndHours);
			newState.dateAndHours = allDatesAndHours;

			this.setState(newState);
		}

		if (!ptoRequest) {
			return;
		}
		['dateAndHours', 'signatureName', 'signatureDate', 'ptoCashOutTotalHours'].forEach((key) => {
			if (_.isNil(ptoRequest[key])) {
				return;
			}
			newState[key] = ptoRequest[key];
		});
		const { paidType } = ptoRequest;
		if (paidType === 'ptoPaid') {
			newState.ptoPaid = 'ptoPaid';
		} else if (paidType === 'ptoPaidSickPaid') {
			newState.ptoPaid = 'ptoPaidSickPaid';
		} else if (paidType === 'ptoCashOut') {
			newState.ptoPaid = 'ptoCashOut';
		}

		this.setState(newState);
	};

	addDateAndHour = () => {
		const ruleName = 'dateAndHours';
		this.setState({
			[ruleName]: this.state[ruleName].concat([
				{
					date: '',
					hours: '',
				},
			]),
		});
	};

	removeDateAndHour = (index) => {
		const ruleName = 'dateAndHours';
		const inputs = this.state[ruleName].slice();
		inputs.splice(index, 1);
		this.setState({ [ruleName]: inputs });
	};

	handleSave = () => {
		const { addPtoRequest, updatePtoRequest, showErrors } = this.props;

		const {
			isUpdate,
			ptoRequestId,
			ptoPaid,
			ptoPaidSickPaid,
			ptoCashOut,
			dateAndHours,
			ptoCashOutTotalHours,
			signatureName,
			signatureDate,
			note,
		} = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		if (!ptoPaid && !ptoPaidSickPaid && !ptoCashOut) {
			formFieldError.ptoPaid = 'Please select PTO Paid or PTO Paid "Sick Pay"';
		}

		let min = 0;
		let max = 12;
		if (ptoPaid) {
			min = 8;
		}

		let duplicateDate = {};
		let ptoCashOutTotalHoursNumber;
		let error = '';

		if (ptoPaid || ptoPaidSickPaid) {
			for (const dateAndHour of dateAndHours) {
				const { date, hours } = dateAndHour;
				dateAndHour.hours = _.parseInt(hours);
				if (!date || !hours) {
					error =
						'Missing date or hours.' +
						' Make sure you have a date and hours filled and remove any empty rows';
					continue;
				}

				if (duplicateDate[date]) {
					error = 'Duplicate date detected. Please only choose each date once.';
					continue;
				}

				if (dateAndHour.hours < min) {
					error = `For this paid time off type the minimum hours must be ${min} hours.`;
					continue;
				}

				if (dateAndHour.hours > max) {
					error = `The maximum hours per day must be ${max} hours.`;
					continue;
				}

				duplicateDate[date] = true;
			}

			if (error) {
				formFieldError.dateAndHours = error;
			}
		} else if (ptoCashOut) {
			ptoCashOutTotalHoursNumber = _.parseInt(ptoCashOutTotalHours);
			if (ptoCashOutTotalHours && !ptoCashOutTotalHours.match(/^[0-9]+$/)) {
				formFieldError.ptoCashOutTotalHours = 'PTO Cash Out should only numbers. No half hours.';
			}
			if (!ptoCashOutTotalHoursNumber) {
				formFieldError.ptoCashOutTotalHours = 'PTO Cash Out hours required and must be a number.';
			}
		}

		let paidType;
		if (ptoPaid) {
			paidType = 'ptoPaid';
		} else if (ptoPaidSickPaid) {
			paidType = 'ptoPaidSickPaid';
		} else if (ptoCashOut) {
			paidType = 'ptoCashOut';
		} else {
			formFieldError.ptoPaid = 'Select PTO time off type';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			paidType,
			dateAndHours,
			signatureName,
			signatureDate,
			note,
		};

		if (ptoCashOutTotalHoursNumber) {
			params.ptoCashOutTotalHours = ptoCashOutTotalHoursNumber;
		}

		if (!isUpdate) {
			addPtoRequest({
				params,
			});
		} else {
			params.ptoRequestId = ptoRequestId;
			updatePtoRequest({
				params,
			});
		}
	};

	renderUpdateOptions = () => {
		return (
			<Grid item xs={12}>
				<FormSubmitButton onClick={this.handleSave} buttonText={'Submit PTO Request'} />
			</Grid>
		);
	};

	render() {
		const { authUser } = this.props;
		const { isUpdate, isAddRequired } = this.state;
		const action = isUpdate ? 'Update PTO Request' : 'New PTO Request';

		return (
			<FormContainer headline={`${action}`}>
				<Grid item xs={12}>
					<Note>
						If you are not{' '}
						<strong>
							{authUser.firstName} {authUser.lastName}{' '}
						</strong>
						please log out and log back in under your account.
					</Note>

					{isUpdate && (
						<Note>
							<strong>Note</strong> : You cannot update a request once submitted. If a change needs
							to be made please cancel this request and submit a new one.
						</Note>
					)}
				</Grid>
				{isAddRequired && (
					<Grid item xs={12}>
						<Note>
							HR has added PTO dates to the schedule and they are automatically filled in below.
						</Note>
					</Grid>
				)}
				<SectionHeader label={'PAID TIME OFF TYPE'} gridProps={{ xs: 12 }} />
				<FormCheckbox
					{...this.setForm('ptoPaid', 'PTO Paid', false, false)}
					gridProps={{ md: 3 }}
					disabled={isUpdate}
				/>
				<FormCheckbox
					{...this.setForm('ptoPaidSickPaid', 'PTO Paid Sick Pay', false, false)}
					gridProps={{ md: 4 }}
					disabled={isUpdate}
				/>

				{/*
				<FormCheckbox
					{...this.setForm('ptoCashOut', 'PTO Cash Out', false, false)}
					gridProps={{ md: 4 }}
					disabled={isUpdate}
				/>
				*/}

				<SectionHeader label={'Requested Date and Hours'} gridProps={{ xs: 12 }} />
				{this.renderRequestedHoursSection()}

				<SectionHeader label={'Sign and Date'} gridProps={{ xs: 12 }} />
				{!isUpdate && (
					<Grid item xs={12}>
						<Note>
							By signing this PTO Request <strong>you have verified on Exponent HR</strong> that you
							have the available hours to use for this PTO Request. <br />
							Click{' '}
							<strong>
								<a
									href="https://www.exponenthr.com/service/EmpLogon.asp"
									target="_blank"
									rel="noreferrer noopener"
								>
									here
								</a>{' '}
							</strong>
							to sign into ExponentHR to check available PTO hours.
						</Note>
					</Grid>
				)}
				<Grid item md={8} xs={12}>
					<Grid container spacing={3}>
						<FormText
							{...this.setForm(`signatureName`, 'Type full name', true)}
							gridProps={{ xs: 7 }}
							withControl={true}
							InputProps={{
								readOnly: isUpdate,
							}}
						/>
						<FormDatePicker
							{...this.setForm(`signatureDate`, 'Date', true)}
							gridProps={{ xs: 5 }}
							readOnly={isUpdate}
						/>
					</Grid>

					<Grid container spacing={3}></Grid>
				</Grid>
				<SectionHeader label={'Extra notes'} gridProps={{ xs: 12 }} />
				<Grid item xs={12}>
					<FormTextArea
						{...this.setForm(
							'note',
							`Any extra notes for your supervisor or HR about this PTO request`
						)}
						rows={2}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormSubmitButton onClick={this.handleSave} buttonText={'Submit PTO Request'} />
				</Grid>
			</FormContainer>
		);
	}

	renderRequestedHoursSection() {
		const { ptoPaid, ptoPaidSickPaid, ptoCashOut } = this.state;

		if (ptoPaid || ptoPaidSickPaid) {
			return this.renderPtoPaidDateAndHours();
		} else if (ptoCashOut) {
			return this.renderPtoCashOutHours();
		} else {
			return (
				<div style={{ padding: 20, color: '#999', fontStyle: 'italic' }}>
					Select a "Paid Time Off Type" above first for options.
				</div>
			);
		}
	}

	renderPtoPaidDateAndHours() {
		const { classes } = this.props;
		const { isUpdate, dateAndHours = [], ptoPaid, ptoPaidSickPaid, ptoCashOut } = this.state;

		// figure out what state we are in
		let totalHours = 0;
		for (const dateHour of dateAndHours) {
			const { hours } = dateHour;
			if (_.isNumber(parseInt(hours))) {
				totalHours += parseInt(hours);
			}
		}

		let hoursHelpText = '';
		if (ptoPaid) {
			hoursHelpText = 'Min of 8 hours, max of 12 hours';
		} else if (ptoPaidSickPaid) {
			hoursHelpText = 'Max of 12 hours';
		} else if (ptoCashOut) {
			hoursHelpText = '1 hour increments';
		}

		return (
			<>
				{dateAndHours.map((row, index) => {
					const prefix = `dateAndHours.${index}`;
					return (
						<Grid item lg={10} md={12} xs={12} className={classes.groupContainer} key={prefix}>
							<Grid container spacing={3}>
								<FormDatePicker
									{...this.setForm(`${prefix}.date`, 'Date')}
									gridProps={{ xs: 8 }}
									readOnly={isUpdate}
								/>
								<FormText
									{...this.setForm(`${prefix}.hours`, 'Hours Paid')}
									gridProps={{ xs: 3 }}
									withControl={true}
									helpText={hoursHelpText}
									InputProps={{
										readOnly: isUpdate,
									}}
								/>
								{index !== 0 && (
									<Grid item xs={1} style={{ display: 'flex', alignItems: 'center' }}>
										{!isUpdate && (
											<IconButton
												color="primary"
												className={classes.deleteButton}
												onClick={() => this.removeDateAndHour(index)}
											>
												<DeleteIcon />
											</IconButton>
										)}
									</Grid>
								)}
							</Grid>
						</Grid>
					);
				})}
				{!isUpdate && (
					<Grid item xs={12}>
						<Button
							variant="contained"
							className={classes.addGroupButton}
							onClick={() => this.addDateAndHour()}
						>
							Add Another Date
						</Button>
					</Grid>
				)}
				<Grid item xs={8}>
					<div
						style={{ display: 'flex' }}
						className={isUpdate ? classes.updateTotalSection : classes.totalSection}
					>
						{!totalHours && (
							<div style={{ color: '#666', fontStyle: 'italic', fontSize: 18 }}>
								Enter your hours above to calculate total
							</div>
						)}

						{!!totalHours && (
							<>
								<div style={{ marginRight: 5 }}>
									<strong>Total Hours to Request: </strong>
								</div>
								{dateAndHours.length > 1 &&
									dateAndHours.map((dateAndHour, index) => {
										return (
											<div key={`addHour.${index}`}>
												{index !== 0 && <span style={{ padding: '0px 4px' }}>+</span>}{' '}
												{dateAndHour.hours}
											</div>
										);
									})}
								<div className={classes.total} style={{ marginLeft: 7 }}>
									{' '}
									= {totalHours} hours
								</div>
							</>
						)}
					</div>
				</Grid>
			</>
		);
	}

	renderPtoCashOutHours() {
		const { classes } = this.props;
		const { isUpdate } = this.state;

		return (
			<Grid item lg={10} md={12} xs={12} className={classes.groupContainer}>
				<Grid container spacing={3}>
					<FormText
						{...this.setForm(`ptoCashOutTotalHours`, 'Total Hours To Cash Out')}
						gridProps={{ xs: 6 }}
						withControl={true}
						helpText={'Min of 1 hour'}
						InputProps={{
							readOnly: isUpdate,
						}}
					/>
				</Grid>
			</Grid>
		);
	}
}

SavePtoRequest.propTypes = {
	getPtoRequest: PropTypes.func.isRequired,
	addPtoRequest: PropTypes.func.isRequired,
	updatePtoRequest: PropTypes.func.isRequired,
	ptoRequest: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	PtoRequestContainer,
	PtoRequiredRequestContainer,
])(SavePtoRequest);
